import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { PublicRoute } from '../components/PublicRoute';
import SignupPage from '../../pages/SignupPage';
import PaymentSuccessPage from '../../pages/PaymentSuccessPage';
import PaymentCancelPage from '../../pages/PaymentCancelPage';

const DashboardLoginRedirect: React.FC = () => {
  useEffect(() => {
    window.location.href = '/dashboard/login';
  }, []);

  return null;
};

/**
 * Authentication-related routes
 */
export const authRoutes = (
  <>
    <Route path="/login" element={
      <DashboardLoginRedirect />
    } />
    <Route path="/signup" element={
      <PublicRoute>
        <SignupPage />
      </PublicRoute>
    } />
    <Route path="/payment/success" element={<PaymentSuccessPage />} />
    <Route path="/payment/cancel" element={<PaymentCancelPage />} />
  </>
);










